<i [ngClass]="'fa fa-' + action + ' ' + backgroundColor"
   aria-hidden="true"
   (click)="clicked.emit()"
></i>